import { isPartialType } from '../../../courses/courses/curriculum/utils/is-partial-type'
import {
  ActionEnrollInCourseEditInterface,
  ActionEnrollInCourseEditWithPartialAccessInterface,
} from '../types/automation-rule-actions-edit-interface'

export const isCoursePartialAccessAction = (
  action: ActionEnrollInCourseEditInterface,
): action is ActionEnrollInCourseEditWithPartialAccessInterface => {
  return isPartialType(action.accessType)
}
